/* eslint-disable consistent-return */
class CopyButton {
  constructor() {
    this.selectors = {
      copyButton: '.js-header-block__social-copy-button',
    };

    this.DOM = {
      copyButtons: document.querySelectorAll(this.selectors.copyButton),
    };

    this.init();
  }

  init() {
    this.DOM.copyButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const text = window.location.href;

        try {
          navigator.clipboard.writeText(text);
        } catch (err) {
          return false;
        }
      });
    });
  }
}

export default new CopyButton();
